import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row px-4 py-2" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-md-5"
}
const _hoisted_3 = { class: "form-group col-12" }
const _hoisted_4 = { for: "referral-race" }
const _hoisted_5 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Payment Source (Check all that apply) ")
const _hoisted_7 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "form-check p-0" }
const _hoisted_11 = { class: "px-2 w-100" }
const _hoisted_12 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_13 = ["id", "value", "checked", "disabled", "onChange"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "me-1" }
const _hoisted_16 = { class: "col-12 col-md-5" }
const _hoisted_17 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_18 = {
  id: "Referral_Medicare_Number_Label",
  for: "medicare-number"
}
const _hoisted_19 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Medicare Number ")
const _hoisted_21 = { class: "form-group col-12" }
const _hoisted_22 = {
  for: "mbi-number",
  id: "Mbi_Number_Label"
}
const _hoisted_23 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Medicare Beneficiary Identifier (MBI) ")
const _hoisted_25 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_26 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["value", "disabled"]
const _hoisted_30 = { class: "form-group row" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "form-check custom-checkbox form-check-inline mt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-medicare-beneficiary-identification-na"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "N/A- Not Applicable")
], -1 /* HOISTED */)
const _hoisted_34 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" }),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cms.gov/Medicare/New-Medicare-Card/Providers/Providers-and-office-managers.html",
    target: "_blank"
  }, " Click here to review CMS guidelines on the New Medicare Beneficiary Identifier ")
], -1 /* HOISTED */)
const _hoisted_36 = { class: "form-group col-12" }
const _hoisted_37 = { for: "medicaid-number" }
const _hoisted_38 = {
  key: 0,
  class: "badge me-1"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Medicaid Number ")
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "form-group row mb-0 ms-1" }
const _hoisted_42 = { class: "form-check custom-radio form-check-inline mt-2" }
const _hoisted_43 = ["value", "checked"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-medicaid-pending"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Medicaid is pending")
], -1 /* HOISTED */)
const _hoisted_45 = { class: "form-group row ms-1" }
const _hoisted_46 = { class: "form-check custom-radio form-check-inline mt-2" }
const _hoisted_47 = ["value", "checked"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-no-medicaid"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Not a Medicaid Recipient")
], -1 /* HOISTED */)
const _hoisted_49 = { class: "col-12 col-md-10" }
const _hoisted_50 = {
  key: 1,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EligibilityCheck = _resolveComponent("EligibilityCheck")!
  const _component_PayorTable = _resolveComponent("PayorTable")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Payer Information",
    type: _ctx.isHisSection ? 'his-section' : 'default-section',
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isHisSection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  (_ctx.isHisSection)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "A1400"))
                    : _createCommentVNode("v-if", true),
                  _hoisted_6,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_7, _hoisted_9)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.payerSourceTooltip) }]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentSources, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input au-target",
                          id: `source${value.name}`,
                          value: value.value,
                          checked: _ctx.referral.paymentSource?.includes(value.value),
                          disabled: 
                                            (_ctx.referral.paymentSource?.length > 0 &&
                                                !_ctx.isNoPaymentSourceChecked &&
                                                value.name === 'No payer source') ||
                                            (_ctx.isNoPaymentSourceChecked && value.name !== 'No payer source')
                                        ,
                          onChange: ($event: any) => (_ctx.addPaymentSource(value.value))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `source${value.name}`
                        }, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(value.name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_14)
                      ])
                    ])
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_16, [
          (!_ctx.referral.medicareNumberNA && !!_ctx.referral.medicareNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, [
                  (_ctx.isHisSection)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "A0600B"))
                    : _createCommentVNode("v-if", true),
                  _hoisted_20
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.referral.medicareNumber), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "A0600B"))
                : _createCommentVNode("v-if", true),
              _hoisted_24,
              (!_ctx.referral.medicareBeneficiaryIdentificationNA)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "*"))
                : _createCommentVNode("v-if", true),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_26, _hoisted_28)), [
                [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.mbiTooltip) }]
              ])
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(["form-control", `${!_ctx.v$.referral.medicareBeneficiaryIdentification.$error ? '' : 'field-invalid'}`]),
              maxlength: "50",
              name: "mbi-number",
              type: "text",
              placeholder: "Enter Medicare Beneficiary Identifier (MBI)",
              value: _ctx.formatToUppercase(_ctx.referral.medicareBeneficiaryIdentification),
              disabled: _ctx.referral.medicareBeneficiaryIdentificationNA,
              onChange: _cache[0] || (_cache[0] = (e) => _ctx.handleMedicareNumber(e)),
              onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.medicareBeneficiaryIdentification.$touch && _ctx.v$.referral.medicareBeneficiaryIdentification.$touch(...args)))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_29),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-medicare-beneficiary-identification-na",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.medicareBeneficiaryIdentificationNA) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.referral.medicareBeneficiaryIdentificationNA]
                  ]),
                  _hoisted_33
                ])
              ])
            ]),
            (_ctx.v$.referral.medicareBeneficiaryIdentification.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Medicare Beneficiary Identifier is required unless N/A is checked."))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("label", _hoisted_37, [
              (_ctx.isHisSection)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "A0700"))
                : _createCommentVNode("v-if", true),
              _hoisted_39
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              maxlength: "50",
              placeholder: "Enter Medicaid Number",
              name: "medicaid-number",
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.medicaidNumber) = $event)),
              disabled: 
                                _ctx.otherMedicaid == _ctx.otherMedicaidEnum?.MedicaidPending ||
                                _ctx.otherMedicaid == _ctx.otherMedicaidEnum?.NotAMedicaid
                            
            }, null, 8 /* PROPS */, _hoisted_40), [
              [_vModelText, _ctx.referral.medicaidNumber]
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "referral-medicaid-pending",
                  name: "other-medicaid",
                  class: "form-check-input au-target",
                  value: _ctx.otherMedicaidEnum.MedicaidPending,
                  checked: _ctx.otherMedicaid === _ctx.otherMedicaidEnum.MedicaidPending,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.otherMedicaidRadioClick(_ctx.otherMedicaidEnum.MedicaidPending)))
                }, null, 8 /* PROPS */, _hoisted_43),
                _hoisted_44
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "referral-no-medicaid",
                  name: "other-medicaid",
                  class: "form-check-input au-target",
                  value: _ctx.otherMedicaidEnum?.NotAMedicaid,
                  checked: _ctx.otherMedicaid === _ctx.otherMedicaidEnum?.NotAMedicaid,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.otherMedicaidRadioClick(_ctx.otherMedicaidEnum?.NotAMedicaid)))
                }, null, 8 /* PROPS */, _hoisted_47),
                _hoisted_48
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_EligibilityCheck, {
            "first-name": _ctx.referral.firstName,
            "last-name": _ctx.referral.lastName,
            gender: _ctx.referral.gender,
            "location-id": _ctx.referral.locationId,
            "date-of-birth": _ctx.referral.dateOfBirth,
            "medicare-number": _ctx.referral.medicareNumber,
            "mbi-number": _ctx.referral.medicareBeneficiaryIdentification,
            "medicare-number-na": _ctx.referral.medicareNumberNA,
            "mbi-number-na": _ctx.referral.medicareBeneficiaryIdentificationNA,
            application: _ctx.referral.application,
            "account-id": _ctx.referral.accountId,
            "missing-url": _ctx.eligibilityMissingUrl
          }, null, 8 /* PROPS */, ["first-name", "last-name", "gender", "location-id", "date-of-birth", "medicare-number", "mbi-number", "medicare-number-na", "mbi-number-na", "application", "account-id", "missing-url"])
        ]),
        (_ctx.referral.patientId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createVNode(_component_PayorTable, {
                "add-new-payer": _ctx.addNewPayer,
                "get-current-patient-payors": _ctx.getCurrentPatientPayors,
                "get-patient-payors": _ctx.getPatientPayors,
                "update-patient-payor": _ctx.updatePatientPayor,
                "delete-patient-payor": _ctx.deletePatientPayor,
                referral: _ctx.referral,
                "provider-id": _ctx.providerId
              }, null, 8 /* PROPS */, ["add-new-payer", "get-current-patient-payors", "get-patient-payors", "update-patient-payor", "delete-patient-payor", "referral", "provider-id"])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["type", "application-id"]))
}